import { replace, useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar/Topbar";
import { Star } from "../../assets/img";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import moment from "moment";
import { checkPermission } from "../redux/api/PermissionManager";

const ReviewView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.data;
  console.log("data review", data);

  const handleStatus = async (status) => {
    if (!checkPermission("CAN-EDIT-REVIEW")) return;
    const payload = {
      review_id: data?.id,
      status: status,
    };

    const res = await post(URLS.REVIEW_STATUS, payload);
    console.log("review status", res);
    if (res?.status === "success") {
      toast.success(
        data?.status === 1
          ? res?.message
          : `Review ${status === 2 ? "Activated" : "Deactivated"} Successfully`,
      );

      navigate("/review", {
        state: { tab: status === 3 ? "Deactivate" : "Active", replace: true },
      });
    }
  };

  return (
    <>
      <Topbar header={"Review"} back={true} />

      <div className="row mt-5">
        <form className="d-flex flex-wrap gap-5">
          <div className="col-md-5"></div>
          <div className="col-md-5 d-flex ae-js gap-4">
            <div className="px-4 py-2 shadow-sm radius-10">
              <p className=" fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Date
              </p>
              <h6 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                {moment(data?.created_at).format("DD-MM-YYYY")}
              </h6>
            </div>
            <div className="shadow-sm px-4 py-2 radius-10">
              <p className=" fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Time
              </p>
              <h6 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                {moment(data?.created_at).format("hh:mm:ss")}
              </h6>
            </div>
          </div>
          <div className="col-md-5">
            <div>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Property
              </label>
              <input
                value={data?.property_name}
                className="input-box"
                placeholder="property"
                disabled
              />
            </div>
          </div>
          <div className="col-md-5">
            <div>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                User
              </label>
              <input
                className="input-box"
                placeholder="User"
                value={data?.user_name}
                disabled
              />
            </div>
          </div>
          <div className="col-md-5">
            <div>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Booking ID
              </label>
              <input
                value={data?.booking_code}
                className="input-box"
                placeholder="Booking Id"
                disabled
              />
            </div>
          </div>
          <div className="col-md-5">
            <div>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Owner
              </label>
              <input
                value={data?.owner_name}
                className="input-box"
                placeholder="Owner"
                disabled
              />
            </div>
          </div>
          <div className="col-md-5">
            <div style={{ width: "95%" }}>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Review
              </label>
              <div className="d-flex gap-3 mt-2">
                {Array(Math.floor(data?.rating))
                  .fill(0)
                  .map(() => (
                    <img
                      className="Star_icon"
                      src={Star}
                      style={{ height: "30px", width: "30px" }}
                    />
                  ))}
              </div>
            </div>
          </div>
          <div className="col-md-5">
            <div>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Location
              </label>
              <input
                value={`${data?.city},${data?.state}`}
                className="input-box"
                placeholder="Owner"
                disabled
              />
            </div>
          </div>

          <div className="col-md-11">
            <div style={{ width: "95%" }}>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Description
              </label>
              <textarea
                className="input-box"
                value={data?.description}
                placeholder="Text..."
                style={{ minHeight: "131px" }}
                disabled
              />
            </div>
          </div>

          <>
            <div className="col-lg-11 justify-content-start ">
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Status
              </label>
              <div className="d-flex as-js gap-5">
                {(data?.status === 1 || data?.status === 3) && (
                  <button
                    type="button"
                    style={{ width: "200px" }}
                    className="approve-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                    onClick={() => {
                      handleStatus(2);
                    }}
                  >
                    Active
                  </button>
                )}
                {(data?.status === 1 || data?.status === 2) && (
                  <button
                    type="button"
                    style={{ width: "200px" }}
                    className="reject1-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                    onClick={() => {
                      handleStatus(3);
                    }}
                  >
                    Deactivate
                  </button>
                )}
              </div>
            </div>
          </>
        </form>
      </div>
    </>
  );
};

export default ReviewView;
